var _dec, _class;

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, html } from '@sick-davinci/ce-decorators';
import { style } from './Breadcrumb.style';
/**
 * A `davinci-breadcrumb` indicates the current page’s location.
 * It consists of several `davinci-breadcrumb-item`s which contain a link to a specific page.
 * 
 * @example
 * ```html
 * <davinci-breadcrumb>
 *    <davinci-breadcrumb-item href="/home" label="Home"></davinci-breadcrumb-item>
 *    <davinci-breadcrumb-item label="Search" onclick="console.log('clicked')"></davinci-breadcrumb-item>
 * </davinci-breadcrumb>
 * ```
 * @slot {davinci-breadcrumb-item[]} list of `davinci-breadcrumb-item`
 */

export let Breadcrumb = (_dec = Component({
  tag: 'davinci-breadcrumb',
  style
}), _dec(_class = class Breadcrumb extends CustomElement {
  render() {
    return html`
        <div class="scroll-container">
          <slot></slot>
        </div>
    `;
  }

}) || _class);
